import React from 'react';

import { useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { useNavigation } from '@navigation';

interface AccessDeniedHelperResources {
	title: string;
	subtitle: string;
	backToHomepage: string;
}

interface AccessDeniedHelperOutput {
	resources: AccessDeniedHelperResources;
	onHandleLeave: () => void;
}

export const useAccessDeniedHelper = (): AccessDeniedHelperOutput => {
	const t = useTranslation();
	const { exit } = useNavigation();

	const resources: AccessDeniedHelperResources = {
		title: t('placeholders.accessDenied.title'),
		subtitle: t('placeholders.accessDenied.subtitle'),
		backToHomepage: t('general.backToHomepage'),
	};

	const onHandleLeave = React.useCallback(() => {
		exit();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { resources, onHandleLeave };
};
